import { gql } from "@apollo/client";

export const CREATE_MAILING_LIST = gql`
  mutation CreateMailingList($input: CreateMailingListInput!) {
    createMailingList(input: $input) {
      success
      error
      mailingList {
        id
        description
      }
    }
  }
`;
